import { render, staticRenderFns } from "./ReferralSurvey.vue?vue&type=template&id=7c2627d0&scoped=true&"
import script from "./ReferralSurvey.vue?vue&type=script&lang=js&"
export * from "./ReferralSurvey.vue?vue&type=script&lang=js&"
import style0 from "./ReferralSurvey.vue?vue&type=style&index=0&id=7c2627d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2627d0",
  null
  
)

component.options.__file = "ReferralSurvey.vue"
export default component.exports